import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localeIt from '@angular/common/locales/it';
import localePl from '@angular/common/locales/pl';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from '@core/core.module';
import { TranslateService } from '@ngx-translate/core';
import { de, en, es, fr, it, pl } from './modules/_i18n';
import { TranslationLoaderService } from '@core/services/translation-loader.service';
import { providePrimeNG } from 'primeng/config';
import { LaraSubset } from '@core/primeng-preset';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    // BrowserModule first: it provides the plain RendererFactory2, and a later import wins. If it
    // came after CoreModule it would replace the animation renderer from provideAnimations() and
    // every [@trigger] / (@trigger.done) binding (e.g. the ng-gallery lightbox) throws NG05105.
    BrowserModule,
    CoreModule,
    AppRoutingModule,
  ],
  providers: [
    providePrimeNG({
      theme: {
        preset: LaraSubset,
        options: { darkModeSelector: false }
      }
    }),
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(translationLoader: TranslationLoaderService,
              translate: TranslateService) {

    // Load global translations
    translationLoader.loadTranslations(en, de, fr, es, it, pl);

    // Add languages
    translate.addLangs(['en', 'de', 'fr', 'es', 'it', 'pl']);

    // Locale data for date/number pipes
    registerLocaleData(localeFr);
    registerLocaleData(localeEs);
    registerLocaleData(localeIt);
    registerLocaleData(localePl);
  }

}
